export interface PreventZoomConfig {
	pinch: boolean;
	doubleTap: boolean;
	wheel: boolean;
	buttons: string[];
}

const BASE_CONFIG: PreventZoomConfig = {
	pinch: true,
	doubleTap: true,
	wheel: true,
	buttons: ["+", "-", "=", "0"],
};

/**
 * Prevent browser zooming
 * @param {PreventZoomConfig} options
 */
export const preventZoom = (options?: Partial<PreventZoomConfig>) => {
	const config = Object.assign({}, BASE_CONFIG, options);

	if (config.pinch) {
		document.addEventListener("touchstart", (e) => e.touches.length > 1 && e.preventDefault(), { passive: false });
		document.addEventListener("gesturestart", (e) => e.preventDefault(), { passive: false });
	}

	if (config.doubleTap) {
		document.addEventListener("dblclick", (e) => e.preventDefault(), { passive: false, capture: true });
	}

	if (config.wheel) {
		document.addEventListener("wheel", (e) => (e.ctrlKey || e.metaKey) && e.preventDefault(), { passive: false });
	}

	if (config.buttons?.length) {
		document.addEventListener("keydown", (e) => (e.ctrlKey || e.metaKey) && config.buttons.includes(e.key) && e.preventDefault());
	}
};
